import React from "react";
import { useTranslation } from "react-i18next";

import CardColumn from "components/CardColumn";
import TaskMenu from "./TaskMenu";
import PriorityMarker from "components/Tasks/PriorityMarker";
import { useGetConvertedUserTime } from "hooks/useTimezone";

interface Props {
	id: string;
	title: string;
	status: "Active" | "Completed";
	started: string;
	dueDate: string;
	priority: "LOW" | "NORMAL" | "HIGH";
	assignee: string;
}

const TaskCard = ({
	id,
	title,
	status,
	started,
	dueDate,
	priority,
	assignee,
}: Props) => {
	const { t } = useTranslation();

	const startedConverted = useGetConvertedUserTime(started);
	const dueDateConverted = useGetConvertedUserTime(dueDate);

	return (
		<>
			<CardColumn className="task-card__title" width="xl">
				{title}
			</CardColumn>
			<CardColumn className="task-card__status" width="xs">
				{status}
			</CardColumn>
			<CardColumn className="task-card__started" width="md">
				{startedConverted}
			</CardColumn>
			<CardColumn className="task-card__due-date" width="xs">
				{dueDateConverted || t("main.text.na")}
			</CardColumn>
			<CardColumn className="task-card__priority" width="xs">
				<PriorityMarker priority={priority} />
			</CardColumn>
			<CardColumn className="task-card__assignee" width="md">
				<div className="task-card--heading--mobile__assignee">
					{t("main.tasks.headings.assignee")}
				</div>
				<div>{assignee || t("main.text.na")}</div>
			</CardColumn>
			<CardColumn className="task-card__menu">
				{status === "Active" ? (
					<TaskMenu id={id} />
				) : (
					<div className="task-card__menu-empty"></div>
				)}
			</CardColumn>
		</>
	);
};

export default TaskCard;
